<template>
  <RouterLink
    class="navbar-brand mr-1"
    to="/"
  >
    <!-- <img class="img-fluid" src="@/assets/theme/img/logo.png" /> -->
    <canvas id="brand-canvas" />
    <!-- <div class="test"> -->
    <!-- {{ brand.text }} ({{ activeFont }}) -->
    <!-- </div> -->
    <!-- <div id="colors" /> -->
  </RouterLink>
</template>

<script>
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-multi-assign */
/* eslint-disable no-param-reassign */
import { sync } from 'vuex-pathify';
import randomColor from 'randomcolor';

export default {
  data() {
    return {
      brand: this.$config.style.brand,
    };
  },

  computed: {
    ...sync(['site.activeFont']),
  },

  mounted() {
    Bus.$on('font_updated', () => {
      this.$nextTick(() => {
        this.init();
        $('.navbar-brand .test').css('font-family', `'${this.activeFont}'`);
      });
    });

    Bus.$emit('font_updated');
  },

  beforeDestroy() {
    Bus.$off('font_updated');
  },

  methods: {
    init() {
      this.brand.font = this.activeFont;
      this.particleText('brand-canvas', this.brand.text, this.brand.font, this.brand.fontSize, this.brand.width, this.brand.height);
    },

    particleText(canvasId, text, font, fontSize, width, height) {
      // based on
      // https://codepen.io/Joey-z-rp/pen/yoxErZ
      // other cool particle text effects:
      // https://codepen.io/comajama/pen/eMmYXe
      // https://codepen.io/hendrysadrak/pen/BNvrMm
      const canvas = document.getElementById(canvasId);
      const w = (canvas.width = width);
      const h = (canvas.height = height);
      const ctx = canvas.getContext('2d');

      const gridX = 5;

      const gridY = 5;

      const useRandomColor = false;
      let colorArray;

      if (useRandomColor) {
        const ncolors = 500;
        colorArray = randomColor({
          count: ncolors,
          seed: 1,
          // luminosity: 'random',
          // hue: 'random',
          luminosity: 'light', // bright, light or dark
          hue: 'pink', // red, orange, yellow, green, blue, purple, pink and monochrome
        });
      } else {
        colorArray = ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722'];
      }

      // for (const i in colorArray) {
      //   const e = $('<div class="color"></div>');
      //   e.css('background-color', colorArray[i]);
      //   $('#colors').append(e);
      // }

      // console.log(colorArray);

      // for (let i in colors) {
      //   let e = $('<div class="color"></div>');
      //   e.css('background-color', colors[i]);
      //   $('#colors').append(e);
      // }

      function Particle(x, y) {
        this.x = x;
        this.y = y;
        this.radius = 1;
        this.colorArray = colorArray;
        this.color = this.colorArray[Math.floor(Math.random() * this.colorArray.length)];
        this.scale = 0;
        this.speed = Math.random() * 360;
        this.initialScale = Math.random() + 1;
        this.speedIncrement = Math.random() + 5;
      }

      Particle.prototype.draw = function draw(context) {
        this.scale = this.initialScale + Math.sin((this.speed * Math.PI) / 180);
        this.speed += this.speedIncrement;
        context.save();
        context.fillStyle = this.color;
        context.scale(this.scale, this.scale);
        context.beginPath();
        context.arc(this.x / this.scale, this.y / this.scale, this.radius, 0, Math.PI * 2, true);
        context.fill();
        context.restore();
      };

      function Shape(text) {
        this.text = text;
        this.font = font;
        this.fontSize = fontSize;
        this.x = w / 2;
        this.y = h / 2 + this.fontSize / 2.7;
        this.placement = [];
      }

      Shape.prototype.getParticles = function getParticles(context) {
        context.save();
        context.textAlign = 'center';
        context.font = `${this.fontSize}px '${this.font}'`;
        context.fillText(this.text, this.x, this.y);
        context.restore();
        const data = context.getImageData(0, 0, w, h).data;

        for (let row = 0; row < h; row += gridY) {
          for (let col = 0; col < w * 4; col += 4 * gridX) {
            if (data[row * w * 4 + col] || data[row * w * 4 + col + 1] || data[row * w * 4 + col + 2] || data[row * w * 4 + col + 3]) {
              // console.log((col/4+1),row);
              const particle = new Particle(col / 4 + 1, row);
              this.placement.push(particle);
            }
          }
        }
      };

      Shape.prototype.display = function display(context) {
        for (let i = 0; i < this.placement.length; i += 1) {
          this.placement[i].draw(context);
        }
      };

      const shape = new Shape(text);
      shape.getParticles(ctx);

      (function draw() {
        ctx.clearRect(0, 0, w, h);
        shape.display(ctx);
        window.requestAnimationFrame(draw);
      }());
    },
  },
};
</script>

<style>
/* @import url('https://fonts.googleapis.com/css?family=Gloria+Hallelujah'); */
/* @import url('https://fonts.googleapis.com/css?family=Asar'); */
/* @import url('https://fonts.googleapis.com/css?family=Open+Sans'); */
body {
  margin: 0;
  padding: 0;
}
.navbar-brand {
  transform: scale(0.33);
  margin-left: -180px;
  margin-top: -30px;
  height: 45px;
}
canvas {
  background-color: #000;
  border-radius: 30px;
  padding: 9px;
  position: relative;
  top: 5px;
  left: -10%;
}
.navbar-brand .test {
  position: absolute;
  font-size: 60px;
  left: 100%;
  top: 30px;
  /* display: inline; */
  /* font-family: Arial, Helvetica, sans-serif; */
}

.color {
  width: 50px;
  height: 30px;
  margin: 10px;
  float: left;
}
</style>

<style lang="scss">
canvas {
  filter: grayscale(90%) saturate(5) brightness(1.5) drop-shadow(4px 4px 5px rgba(0,0,0,0.9));
}
</style>
